<template>
  <div class="content">
    <ul>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio-1" name="radio" type="radio" checked />
          <label for="radio-1" class="radio-label">Hour to date</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio-2" name="radio" type="radio" />
          <label for="radio-2" class="radio-label">Last</label>
          <input type="number" min="1" class="input--tabs" />
          <label>{{ $t('hours') }}</label>
        </div>
      </li>
      <li class="radio-btn">
        <div class="radio">
          <input id="radio-3" name="radio" type="radio" />
          <label for="radio-3" class="radio-label"></label>
          <input type="number" min="1" class="input--tabs" />
          <label>{{ $t('hours') }}, {{ $t('from') }}</label>
          <select name="day" class="input--tabs">
            <option v-for="day in listDay" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>
          <select name="month" class="input--tabs">
            <option v-for="day in listMonth" :key="day.value" :value="day.value">{{ $t(day.name.toLowerCase()) }}</option>
          </select>
          <select name="day" class="input--tabs">
            <option v-for="day in listYear" :key="day.value" :value="day.value">{{ day.name }}</option>
          </select>

          <select name="day" class="input--tabs">
            <option v-for="hours in listHours" :key="hours.value" :value="hours.value">{{ hours.name }}</option>
          </select>
          <select name="day" class="input--tabs">
            <option v-for="min in listMin" :key="min.value" :value="min.value">{{ min.name }}</option>
          </select>
          <select name="day" class="input--tabs">
            <option v-for="time in listTime" :key="time.value" :value="time.value">{{ time.name }}</option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import dateTime from '@/constants/dateTime'
export default {
  name: 'FilterHours',
  data () {
    return {
      listDay: dateTime.day,
      listMonth: dateTime.month,
      listYear: dateTime.year,
      listHours: dateTime.hours,
      listMin: dateTime.min,
      listTime: dateTime.time
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px;
  .radio-btn {
    padding-bottom: 10px;
    margin: 0.5rem;
    display: flex;
    align-items: center;
    align-content: center;
  }
  .radio {
    display: flex;
    align-items: baseline;
  }
  label {
    color: #a0a8b4;
  }
  .input--tabs {
    margin: 0 4px;
    height: 32px;
    background-image: none;
    border: 1px solid #ccc;
    width: 70px;
    outline: none;
  }
}
</style>
